import { combine, createEvent, createStore, sample } from 'effector'
import { features } from '~/core/flags'
import { model as clock } from '~/shared/clock'
import { HOURS_IN_DAY } from '~/shared/constants'
import { type EpgDateEx } from './index.h'
import { generateWeek, getToday, isSameDate } from './lib'

export const init = createEvent()

// today
export const updateToday = createEvent()

export const $today = createStore<EpgDateEx>(getToday()) //
  .on(updateToday, (current) => {
    const today = getToday()
    return isSameDate(current)(today) ? current : today
  })

// epg week from today to future with yesterday
export const $week = combine(
  { today: $today, epgSettings: features.$epgSettings },
  ({ today, epgSettings }) => {
    const { pastHours, futureHours } = epgSettings || {}
    const daysBeforeToday = Math.ceil(pastHours / HOURS_IN_DAY)
    const daysAfterToday = Math.ceil(futureHours / HOURS_IN_DAY)
    const epgWeekDuration = daysBeforeToday + daysAfterToday + 1
    return generateWeek({
      from: today,
      duration: epgWeekDuration,
      daysBeforeToday,
    })
  }
)

sample({
  clock: [init, clock.$days],
  target: updateToday,
})
